<template>
  <div class="card mt-3">
    <div class="card-body">
      <h5 class="card-title">
        {{ trans("admin.cdr.reassignmentExecution") }}
      </h5>

      <div v-if="execution.source_patient" class="mb-2">
        <button
          type="button"
          class="btn btn-link p-0 text-muted small text-decoration-none"
          :aria-expanded="showSourcePatient"
          @click="showSourcePatient = !showSourcePatient"
        >
          <i
            :class="
              showSourcePatient ? 'fal fa-chevron-down' : 'fal fa-chevron-right'
            "
          />
          {{ trans("admin.cdr.originalPatient") }}
        </button>
        <div v-if="showSourcePatient" class="card p-3 mt-2">
          <div class="row">
            <div class="col-md-6">
              <strong
                >{{ trans("admin.cdr.destinationPatientFirstname") }}:</strong
              >
              {{ execution.source_patient.firstname }}
            </div>
            <div class="col-md-6">
              <strong
                >{{ trans("admin.cdr.destinationPatientLastname") }}:</strong
              >
              {{ execution.source_patient.lastname }}
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <strong>{{ trans("admin.cdr.lookupSsn") }}:</strong>
              {{ execution.source_patient.ssn }}
            </div>
            <div v-if="execution.source_patient.date_of_birth" class="col-md-6">
              <strong>{{ trans("admin.cdr.destinationPatientDob") }}:</strong>
              {{ execution.source_patient.date_of_birth }}
            </div>
          </div>
        </div>
      </div>

      <div v-if="destinationPatient" class="mb-3">
        <button
          type="button"
          class="btn btn-link p-0 text-muted small text-decoration-none"
          :aria-expanded="showDestinationPatient"
          @click="showDestinationPatient = !showDestinationPatient"
        >
          <i
            :class="
              showDestinationPatient
                ? 'fal fa-chevron-down'
                : 'fal fa-chevron-right'
            "
          />
          {{ trans("admin.cdr.selectedDestinationPatient") }}
        </button>
        <div v-if="showDestinationPatient" class="card p-3 mt-2">
          <div class="row">
            <div class="col-md-6">
              <strong
                >{{ trans("admin.cdr.destinationPatientFirstname") }}:</strong
              >
              {{ destinationPatient.firstname }}
            </div>
            <div class="col-md-6">
              <strong
                >{{ trans("admin.cdr.destinationPatientLastname") }}:</strong
              >
              {{ destinationPatient.lastname }}
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <strong>{{ trans("admin.cdr.lookupSsn") }}:</strong>
              {{ destinationPatient.ssn }}
            </div>
          </div>
        </div>
      </div>

      <div class="form-check mb-2">
        <input
          id="reassign-patient-verified"
          class="form-check-input"
          type="checkbox"
          checked
          disabled
        />
        <label class="form-check-label" for="reassign-patient-verified">
          {{ trans("admin.cdr.confirmPatientDetails") }}
        </label>
      </div>

      <div v-if="execution.scope" class="form-check mb-2">
        <input
          id="reassign-scope-acknowledge"
          class="form-check-input"
          type="checkbox"
          checked
          disabled
        />
        <label class="form-check-label" for="reassign-scope-acknowledge">
          {{ execution.scope.label }}
        </label>
      </div>

      <CdrIntegrationAcknowledgements
        :transfers="execution.integration_transfers || []"
        readonly
      />

      <div class="form-check mb-3">
        <input
          id="reassign-acknowledge"
          class="form-check-input"
          type="checkbox"
          checked
          disabled
        />
        <label class="form-check-label" for="reassign-acknowledge">
          {{ trans("admin.cdr.reassignmentAcknowledge") }}
        </label>
      </div>

      <div class="row">
        <div class="col-md-6">
          <strong>{{ trans("admin.cdr.executedBy") }}:</strong>
          {{ execution.executed_by_name }}
        </div>
        <div class="col-md-6">
          <strong>{{ trans("admin.cdr.executedAt") }}:</strong>
          {{ execution.executed_at_formatted }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CdrIntegrationAcknowledgements from "./CdrIntegrationAcknowledgements.vue";

export default {
  components: { CdrIntegrationAcknowledgements },
  props: {
    flag: { type: Object, required: true },
    execution: { type: Object, required: true },
  },
  data() {
    return {
      showSourcePatient: false,
      showDestinationPatient: false,
    };
  },
  computed: {
    destinationPatient() {
      return this.flag.flaggable?.patient ?? null;
    },
  },
};
</script>
